import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Table } from "react-bootstrap";
import {
  getNewUsers,
  getNewUsersPage,
  verify_license,
  deleteNewUser,
} from "./../Redux/Actions/Useraction";
import Paginationcomponent from "../component/pagination";
import notify from "../Hook/useNotification";
import { useTranslation } from "react-i18next";
const Newusers = ({ keyword }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [Deleteloading, setDeleteLoading] = useState(true);
  const [Dataloading, setDataLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState("approved");

  useEffect(() => {
    dispatch(getNewUsers(keyword));
  }, [dispatch, keyword]);

  const handleClose = () => {
    setShow(false);
    setUpdateId(null);
  };
  const handleShow = (id) => {
    setUpdateId(id);
    setShow(true);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
    setDeleteId(null);
  };
  const handleDeleteShow = (id) => {
    setDeleteId(id);
    setShowDelete(true);
  };
  const newuserData = useSelector((state) => state.alluser.newusers);
  const allNewUser = newuserData?.data?.users;

  console.log("newuserData", newuserData);
  const loading = useSelector((state) => state.alluser.loading);

  let pagecount = 0;
  if (newuserData?.paginationresults?.numberOfPages) {
    pagecount = newuserData?.paginationresults?.numberOfPages;
  }

  const getpage = (page) => {
    dispatch(getNewUsersPage(page));
  };
  const handleConfirm = async (id, statusValue) => {
    setDataLoading(true);
    await dispatch(
      verify_license({
        userId: id,
        status: statusValue,
      }),
    );
    setDataLoading(false);
    handleClose();
  };

  const res = useSelector((state) => state.alluser.verifylicense);
  useEffect(() => {
    if (!Dataloading) {
      if (res?.data?.status === "success") {
        notify(t("newusers.notify.license_success"), "success");
        setTimeout(() => {
          window.location.reload();
        }, 400);
      } else {
        notify(t("newusers.notify.license_error"), "error");
      }
      setDataLoading(true);
    }
  }, [Dataloading, res?.data?.status, t]);

  const handleDeleteConfirmed = async (deleteId) => {
    setDeleteLoading(true);
    await dispatch(deleteNewUser(deleteId));
    setDeleteLoading(false);
    handleDeleteClose();
  };

  const responce = useSelector((state) => state.alluser.deletenewuser);
  console.log("delete responce", responce);
  useEffect(() => {
    if (Deleteloading === false) {
      if (responce?.message === "User deactivated successfully") {
        notify(t("newusers.notify.delete_success"), "success");
        setTimeout(() => {
          window.location.reload(false);
        }, 1000);
      } else {
        notify(t("newusers.notify.delete_error"), "error");
      }
      setDeleteLoading(true);
    }
  }, [Deleteloading, responce?.message, t]);

  return (
    <>
      {loading ? (
        <p>{t("newusers.loading")}</p>
      ) : (
        <Table striped bordered hover responsive>
          <thead className="table-dark">
            <tr>
              <th>{t("newusers.table.name")}</th>
              <th>{t("newusers.table.email")}</th>
              <th>{t("newusers.table.role")}</th>
              <th>{t("newusers.table.imagemedicallicense")}</th>
              <th>{t("newusers.table.licenseVerified")}</th>
              <th>{t("newusers.table.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {allNewUser?.length > 0 ? (
              allNewUser.map((user, index) => (
                <tr key={user._id}>
                  <td>
                    {user.firstName} {user.lastName}
                  </td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <a
                      href={user.imagemedicallicense}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#0d6efd",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {t("newusers.link.view_image")}
                    </a>
                  </td>
                  <td>{user.licenseVerified ? "Yes" : "No"}</td>
                  <td>
                    <FaEdit
                      style={{
                        cursor: "pointer",
                        marginRight: 10,
                        color: "#ffc107",
                      }}
                      onClick={() => handleShow(user._id)}
                    />
                    <FaTrash
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      onClick={() => handleDeleteShow(user._id)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  {t("newusers.no_data")}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {pagecount > 1 && (
        <Paginationcomponent pagecount={pagecount} onpress={getpage} />
      )}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("newusers.modal.license.title")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t("newusers.modal.license.body")}</p>

          {/* الجزء الخاص باختيار الحالة */}
          <div className="mt-3">
            <label className="form-label">Action:</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("newusers.modal.cancel")}
          </Button>

          {/* هنا بنبعت الـ updateId والـ selectedStatus اللي اخترناها */}
          <Button
            variant={selectedStatus === "approved" ? "success" : "danger"}
            onClick={() => handleConfirm(updateId, selectedStatus)}
          >
            {t("newusers.modal.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDelete} onHide={handleDeleteClose}>
        <Modal.Header>
          <Modal.Title>{t("newusers.modal.delete.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("newusers.modal.delete.body")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteClose}>
            {t("newusers.modal.cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={() => handleDeleteConfirmed(deleteId)}
          >
            {t("newusers.modal.delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Newusers;
